import { DoubleArrow } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import TypeFilter from '../../../../shared/components/TypeFilter'
import HiddenDesktop from '../../../../shared/styles/HiddenDesktop'
import ScrollSubHeader from '../../../../shared/styles/ScrollSubHeader'
import { CourseType } from '../../models/course'

interface CoursesTypeProps {
  coursetypes: CourseType[]
  filterId: number | null
  handleChangeFilter: (coursetype_id: number) => void
}

const CoursesType = ({ coursetypes, filterId, handleChangeFilter }: CoursesTypeProps) => {
  const { t } = useTranslation(['global'])

  const myElement: HTMLElement | null = document.getElementById('windowCourseClient')
  const midOfWidth = window.innerWidth / 2

  return (
    <>
      <ScrollSubHeader id="windowCourseClient">
        {coursetypes.map((coursetype: any) => (
          <TypeFilter
            key={coursetype.id}
            id={coursetype.id}
            type={coursetype.name}
            categories={[]}
            active={coursetype.id === filterId}
            handleChangeFilter={handleChangeFilter}
          />
        ))}
        <TypeFilter id={null} type={t('all')} categories={[]} active={filterId === null} handleChangeFilter={handleChangeFilter} />
        <HiddenDesktop>
          <IconButton
            sx={{ position: 'absolute', right: 0, top:'17%', zIndex: 10, backgroundColor: 'white' }}
            className="buttonScroll"
            onClick={() => {
              myElement?.scrollBy(midOfWidth, 0)
            }}
          >
            <DoubleArrow />
          </IconButton>
        </HiddenDesktop>
      </ScrollSubHeader>
    </>
  )
}

export default CoursesType
